<!-- If header is inside ion-content, wrap it in ion-item-divider -->
<ng-template [ngIf]="config && config.isContentHeader" [ngIfElse]="sansDivider">
  <ion-item-divider [sticky]="config.sticky" no-padding no-margin
    class="no-padding no-margin ion-no-padding ion-no-margin">
    <ion-header>
      <ion-toolbar #toolbar [ngClass]="config.class">
        <!-- Back Button And Menu Button-->
        <ion-buttons slot="start">
          <ion-button primary *ngIf="config.isBackButtonVisible" color="smartlabel-blue" (click)="goBack()">
            <ion-icon name="arrow-back-outline"></ion-icon>
          </ion-button>
        </ion-buttons>
        <ng-template [ngIf]="config.headerText">
          <ion-text [innerHTML]="config.headerText | safe: 'html'">
          </ion-text>
        </ng-template>

      </ion-toolbar>
    </ion-header>
  </ion-item-divider>
</ng-template>

<!-- If header is outside of ion-content, Dont wrap in ion-item-divider -->
<ng-template #sansDivider>
  <!-- <ion-header *ngIf="config">
    <ion-toolbar #toolbar [ngClass]="config.class">
        <ion-buttons slot="start" *ngIf="config.isMenuButtonVisible">
          <ion-menu-toggle>
            <ion-button primary >
              <ion-icon icon-only name="menu"></ion-icon>
            </ion-button>
          </ion-menu-toggle>
        </ion-buttons>
        <ng-template [ngIf]="config.headerText">
          <ion-text [innerHTML]="config.headerText | safe: 'html'">
          </ion-text>            
        </ng-template>

        <ion-button *ngIf="config?.showLanguageSelector" slot="end" (click)="presentPopover($event)" fill="clear">
          <ion-icon name="globe"></ion-icon>
          <ion-icon name="arrow-dropdown" mode="md"></ion-icon>
        </ion-button>
    
      </ion-toolbar>
  </ion-header> -->
</ng-template>